import { LoadingIcon } from '@sib/ui';

export const Loader = () => (
  <div className="flex h-64 w-full items-center justify-center p-4">
    <LoadingIcon className="text-primary size-24 opacity-50" />
  </div>
);
